export const EMPLOYEE_PROCESS = 'EMPLOYEE_PROCESS';
export const MANAGER_HR_PROCESS = 'MANAGER_HR_PROCESS';
export const EVERYONE_PROCESS = 'EVERYONE_PROCESS';
